import {
  ref, watchEffect, toRefs, watch, Ref,
} from '@nuxtjs/composition-api';

import IBiuroSzczegoly from '~/components/biura/types/IBiuroSzczegoly';

import fetchMarkersFromProp from '../functions/biura/biuro-szczegoly/data/fetchMarkersFromProp';
import getMapFunctions from '../functions/biura/biuro-szczegoly/getMapFunctions';
import buildServiceConfig from '../functions/biura/biuro-szczegoly/serviceConfig/buildServiceConfig';
import loadStylesheet from '../functions/shared/loadStylesheet';
import TClusterRef from '../types/clusterRef';
import IMapBiuroSzczegolyServiceConfig from '../types/IMapBiuroSzczegolyServiceConfig';
import IMapService from '../types/IMapService';
import TMapRef from '../types/mapRef';

const useMapServiceBiuraSzczegoly = (service: IMapService) => {
  const mapRef = ref() as TMapRef;
  const cluster = ref() as unknown as TClusterRef;
  const serviceConfig: IMapBiuroSzczegolyServiceConfig = buildServiceConfig({
    mapRef,
    cluster,
  });

  const mapFunctions = getMapFunctions(serviceConfig);

  watchEffect(() => {
    loadStylesheet(service);
  });

  const { markersInnerState, config } = serviceConfig;
  const { markersProp } = service;

  fetchMarkersFromProp({ markersInnerState, config, markers: markersProp as Ref<IBiuroSzczegoly[]> });

  watch(mapRef, async () => {
    if (!mapRef || !mapRef.value) return;

    await mapFunctions.init(serviceConfig);
  });

  return {
    ...toRefs(serviceConfig.mapState),
    ...mapFunctions,
    config: ref(serviceConfig.config),
    clusterDom: ref(mapFunctions.buildCluster()),
    markersInnerState: toRefs(serviceConfig.markersInnerState),
    mapRef,
    cluster,
  };
};
export default useMapServiceBiuraSzczegoly;
